module.exports = __webpack_public_path__ + "img/spin_btn.2e87bacc.png";